<template>
<v-container>
  <v-card>
    <v-card-text>
      <v-text-field
        v-model="searchUsuario"
        append-icon="mdi-magnify"
        label="Filtrar Pelo Nome"
        single-line
        hide-details
        
      ></v-text-field>
      <v-data-table               
        dense
        :items="listaDeUsrInterno"
        :headers="headersUsrInterno"
        :search="searchUsuario"                
        :loading="isLoadingUI"               
      >
      </v-data-table>
      <v-card-actions>
        <v-btn @click="adicionarUsrInterno"  
          v-if="this.currentUser.role == 'ADMINISTRADOR'">
          Adicionar <v-icon color="primary"> mdi-plus </v-icon></v-btn
        >
      </v-card-actions> 
    </v-card-text>
  </v-card>
  <v-row justify="center">
    <v-dialog  v-model="dlgUsrInterno"  persistent max-width="600px">
      <v-card >
        <v-card-title>Usuário Interno</v-card-title>
        <form>
          <v-card-text>
            <v-text-field
              v-model="usrInterno.cpf"
              label="CPF (remover os ZEROS(0) iniciais)"
              required
              @change="loadUsuariosInternoPorCpf()"
            ></v-text-field>
          </v-card-text>
           <v-card-text>
            <v-text-field
              v-model="usrInterno.email"
              label="E-mail"                
              disabled
            >
            </v-text-field>
            <v-text-field
              v-model="usrInterno.nome"
              label="Nome"                
              disabled
            ></v-text-field>
            <v-text-field
              v-model="usrInterno.username"
              label="Login UFFS"                
              disabled
            ></v-text-field>
             <v-select
              label="Permissão"                
              :items="listaDeRoles"
              item-text="label"
              item-value="valor"
              v-model="usrInterno.role"                
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="salvarUsrInterno" class="mr-4"> Salvar </v-btn> 
            <v-btn @click="cancelarUsrInterno"> Cancelar </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-row>        
</v-container>
</template>

<script>
import * as UsuarioInternoService from "@/services/usuarios-interno.service";

export default {
  data() {
    return {
      currentUser: this.$store.getters.loggedUser,
      usrInterno: {},
      listaDeUsrInterno: [],
      searchUsuario: "",
      dlgUsrInterno: false,
      isLoadingUI: false,
      listaDeRoles: [        
        {
          label:"Comissão Documentação",
          valor:"COMISSAO_DOCUMENTACAO",          
        },
         {
          label:"Comissão PCD",
          valor:"COMISSAO_PCD",          
        },
        {
          label:"Comissão Raça",
          valor:"COMISSAO_RACA",          
        },
        {
          label:"Comissão Renda",
          valor:"COMISSAO_RENDA",          
        },
        {
          label:"Desabilitado",
          valor:null,          
        },
      ],
      headersUsrInterno: [
          {
          text: "Nome",
          align: "start",
          sortable: true,
          value: "nome",
        },
        {
          text: "Login",
          align: "start",
          sortable: true,
          value: "username",
        },
         {
          text: "CPF",
          align: "start",
          sortable: true,
          value: "cpf",
        },               
        {
          text: "Permissão",
          align: "start",
          sortable: false,
          value: "role",
        },
        //{ text: "Ações", value: "actions", sortable: false, align: "center" },
      ],   
    }
  },
  mounted() {
    this.loadUsuariosInterno();
  },
  methods : {
    loadUsuariosInterno(){
      this.isLoadingUI = true;
      UsuarioInternoService.getAll()
      .then( (res) => (this.listaDeUsrInterno = res.data))
      .finally(() => (this.isLoadingUI = false));
    },
    loadUsuariosInternoPorCpf(){      
      this.isLoadingUI = true;    
      UsuarioInternoService.getUsuarioPorCpf(this.usrInterno.cpf)      
      .then( (res) => (this.usrInterno = res.data))
      .finally(() => (this.isLoadingUI = false));
    },
    adicionarUsrInterno(){
      this.dlgUsrInterno = true;
      this.usrInterno = {};
    },
    salvarUsrInterno(){
      this.$nprogress.start();
      UsuarioInternoService.create(this.usrInterno)
        .then((res) => {
          this.$msg.success("Usuário salvo com sucesso!");
          this.dlgUsrInterno = false;
          this.usrInterno = {};
          this.listaDeUsrInterno.push(res.data);
          this.listaDeUsrInterno = [];
          this.loadUsuariosInterno();
        })
      .finally(() => this.$nprogress.done());
    },
    cancelarUsrInterno() {
      this.dlgUsrInterno = false;
      this.usrInterno = {};      
    },
  }
};
</script>